<template>
  <div class='FAQ-page'>
    <el-select v-model='currentProduct' class='product-select'>
      <el-option
        v-for='product in data'
        :key='product.name'
        :label='product.name'
        :value='product.name'></el-option>
    </el-select>
    <div class='faq-container'>
      <ul class='left'>
        <template v-if='currentProduct'>
          <li
            v-for='(type, index) in types'
            :key='type'
            :class='{active: index === typeIndex}'
            @click='handleTypeClick(type, index)'>{{briefName(type)}}</li>
        </template>
      </ul>
      <div class='right' ref='right'>
        <template v-if='currentProduct'>
          <faq-detail v-if='currentQuestion' :type='types[typeIndex]' :question='currentQuestion' @typeChange='handleSubTypeChange'></faq-detail>
          <template v-else>
            <template v-for='(type, index) in types'>
              <div class='type-container' :key='type' :ref='`${type}`'>
                <h3>{{briefName(type)}}</h3>
                <ul>
                  <li
                    v-for='(question, idx) in questions.filter(item => item.name === type)[0].data'
                    :key='question'
                    @click='handleQuestionClick(question, index)'>{{`${idx + 1}. ${briefName(question.slice(question.lastIndexOf('/') + 1))}`}}</li>
                </ul>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import faqDetail from './FAQDetail.vue';
import axios from 'axios';

export default {
  name: 'FAQ',
  components: {
    faqDetail,
  },
  data() {
    return {
      data: [],
      currentProduct: '',
      typeIndex: 0,
      currentQuestion: '',
    }
  },
  computed: {
    questions() {
      let res = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].name === this.currentProduct) {
          res = this.data[i].data;
        }
      }
      return res;
    },
    types() {
      return this.questions.map(item => item.name);
    },
  },
  watch: {
    currentProduct() {
      this.typeIndex = 0;
      this.currentQuestion = '';
      this.$nextTick(() => {
        if (this.types.length > 0) {
          this.$refs.right.scrollTo(0, this.$refs[this.types[0]][0].offsetTop);
        }
      })
    },
  },
  mounted() {
    this.getFAQ();
    this.setMaxHeight();
    window.addEventListener('resize', this.setMaxHeight);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setMaxHeight);
  },
  methods: {
    getFAQ() {
      axios.get('/docs/FAQ/config.json').then(async ({data}) => {
        let flag = false;
        let publicConfig;
        const res = [];
        let index = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].name === this.$route.query.product) {
            index = i;
          }
          if (data[i].extendPublic && !flag) {
            flag = true;
            publicConfig = await this.getPublicConfig();
          }
          res.push(data[i].extendPublic ? this.mergeData(publicConfig, data[i]) : data[i]);
        }
        this.data = res;
        this.currentProduct = this.data.length > 0 ? this.data[index].name : '';
      })
    },
    mergeData(publicConfig, product) {
      if (!product.data) {
        product.data = [];
      }
      const prevLength = product.data.length;
      for (let i = 0; i < publicConfig.length; i++) {
        let index = -1;
        for (let j = 0; j < product.data.length; j++) {
          if (product.data[j].name === publicConfig[i].name) {
            index = j;
            break;
          }
        }
        if (index === -1) {
          product.data.splice(product.data.length - prevLength, 0, publicConfig[i]);
        } else {
          product.data[index].data.unshift(...publicConfig[i].data);
        }
      }
      return product;
    },
    getPublicConfig() {
      return new Promise((resolve) => {
        axios.get('/docs/FAQ/public.json').then(({data}) => {
          resolve(data);
        })
      })
    },
    handleQuestionClick(question, index) {
      this.typeIndex = index;
      this.currentQuestion = question;
      this.$refs.right.scrollTo(0, 0);
    },
    handleTypeClick(type, index) {
      this.typeIndex = index;
      this.currentQuestion = '';
      this.$nextTick(() => {
        this.$refs.right.scrollTo(0, this.$refs[type][0].offsetTop);
      })
    },
    setMaxHeight() {
      let maxHeight = window.innerHeight - 93 - 66 - 165;
      maxHeight = maxHeight < 0 ? 0 : maxHeight;
      this.$refs.right.style.maxHeight = maxHeight + 'px';
    },
    handleSubTypeChange(type) {
      this.currentQuestion = null;
      this.$nextTick(() => {
        this.$refs.right.scrollTo(0, this.$refs[type][0].offsetTop);
      })
    }
  },
}
</script>

<style lang="less" scoped>
.FAQ-page {
  .product-select {
    width:180px;
    margin-bottom: 10px;
  }
  .faq-container {
    display: flex;
    .left {
      width: 180px;
      margin-right: 10px;
      background: #fff;
      padding: 20px 30px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
      li {
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.active, &:hover {
          color: #5584FF;
        }
      }
    }
    .right {
      flex: 1;
      min-height: 300px;
      overflow: auto;
      position: relative;
      .type-container {
        background: #fff;
        padding: 20px;
        +.type-container {
          margin-top: 10px;
        }
        > h3 {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding-bottom: 10px;
          border-bottom: 1px solid #cccccc;
        }
        > ul {
          padding-top: 10px;
          li {
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 32px;
            cursor: pointer;
            + li {
              margin-top: 2px;
            }
            &:hover {
              color: #3B72F2;
            }
            &:active {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>